import Cookies from 'js-cookie';

import {
    jwtTokenIsExpired,
    setJWTTokensForDev,
    getDataFromTokenPayload,
} from '@utils/tokenManipulation';
import getLocaleFromUrl from '@utils/urls/getLocaleFromURL';
import clearSession from '@utils/browserDataManipulators/clearSession';

import auth from '@config/auth.json';

const isDev = process.env.NODE_ENV === 'development';

const refreshToken = async token => {
    try {
        const res = await fetch(`${process.env.NEXT_PUBLIC_OAUTH2_PREFIX}/token/refresh`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'X-Api-Version': '2',
            },
            body: JSON.stringify({
                grant_type: 'refresh_token',
                refresh_token: token,
                client_id: isDev ? auth.LOCAL_CLIENT_ID : auth.CLIENT_ID,
                client_secret: isDev ? auth.LOCAL_CLIENT_SECRET : auth.CLIENT_SECRET,
            }),
        });
        if (res.status === 200) {
            const { data } = await res.json();
            const { attributes } = data;

            // Проверка на роль кабинета
            if (attributes?.access_token && !isDev) {
                const role = getDataFromTokenPayload('user_role');
                const roles_white_list = ['user', 'admin', 'support', 'partner'];
                if (!role) {
                    throw new Error('Role is null');
                }
                if (!roles_white_list.includes(role)) {
                    throw new Error('Role restricted');
                }
            }

            if (isDev && attributes?.refresh_token && attributes?.access_token) {
                setJWTTokensForDev(attributes.access_token, attributes.refresh_token);
            }
            return Promise.resolve();
        }
        return Promise.reject();
    } catch (error) {
        clearSession();
        return Promise.reject();
    }
};

const fetchWithAuth = async (url, options) => {
    try {
        const jwtAccessToken = Cookies.get('jwt_access_token');
        const jwtRefreshToken = Cookies.get('jwt_refresh_token');

        if (!jwtAccessToken && !jwtRefreshToken) {
            const lang = getLocaleFromUrl();
            window.location.href = isDev ? '/ru/auth' : auth.AUTH_URL.replace(':locale', lang);
            throw new Error('refresh token is undefined');
        }

        const accessTokenExpired = jwtTokenIsExpired(jwtAccessToken);
        const refreshTokenExpired = jwtTokenIsExpired(jwtRefreshToken);

        if (accessTokenExpired && !refreshTokenExpired) {
            await refreshToken(jwtRefreshToken);
        }

        if (accessTokenExpired && refreshTokenExpired) {
            clearSession();
        }

        // eslint-disable-next-line no-param-reassign
        options.headers['X-Access-Token'] = Cookies.get('jwt_access_token');
        // eslint-disable-next-line no-param-reassign
        options.credentials = 'include';

        return fetch(url, options);
    } catch (error) {
        return Promise.reject();
    }
};

export default fetchWithAuth;
